module.exports = __webpack_public_path__ + "media/images/product-bottle-b36bdf470a835141b1c00af11c5387b1.png";